import React from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api';

export const useInvoices = () => {
  const { entityRef } = useParams();
  const [busy, setBusy] = React.useState(false);
  const [invoices, setInvoices] = React.useState([]);

  const listInvoices = React.useCallback(
    startDate => {
      setBusy(true);
      const params = Array.isArray(startDate) ? { startDate: startDate[0], endDate: startDate[1] } : { startDate };
      api
        .listInvoices(entityRef, params)
        .then(({ invoices }) => {
          setInvoices(invoices);
        })
        .finally(() => {
          setBusy(false);
        });
    },
    [entityRef]
  );

  return { listInvoices, invoices, busy };
};
